export default __webpack_public_path__ + "static/media/273.aa8163ff.gif";